import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Format a number for display in a mono column. */
export function num(v: number, decimals = 0): string {
  return v.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/**
 * DC bus voltages are stored negative (telecom convention). Display keeps the
 * sign — an operator reading "-48.0 V" and one reading "48.0 V" are looking at
 * different systems.
 */
export function volts(v: number): string {
  return `${v > 0 ? '' : ''}${num(v, 1)} V`;
}
